import { PropTypes } from "prop-types"

import Translate from "../Translate"
import Button from "../Button"
import Heading from "../Heading"

export const ModalHeader = ({ children, onClose }) => (
  <Translate>
    {({ translate }) => (
      <div className="oj-modal-header">
        {Boolean(onClose) && (
          <Button
            className="button-back-top-modal"
            aria-label={translate("accessBackModalButton")}
            onClick={onClose}
          >
            <Translate id="backModalButton" />
          </Button>
        )}
        <Heading cssClassName="title" level={1}>
          {children}
        </Heading>
        {Boolean(onClose) && (
          <Button
            className="close-modal"
            aria-label={translate("accessCloseModalButton")}
            onClick={onClose}
          >
            <Translate id="closeModalButton" />
          </Button>
        )}
      </div>
    )}
  </Translate>
)

ModalHeader.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func
}

export default ModalHeader
